// CA = Customs Assessment

import { Autocomplete, Box, Checkbox, makeStyles, MenuItem, Tag, Theme } from '@freighthub/silhouette-core'
import { useShipmentDetails } from 'features/ShipmentDetails'
import { isEmpty } from 'lodash-es'
import { FC, useMemo } from 'react'
import { useI18n } from 'utils/localisation'

// @ts-expect-error TS(2345) FIXME: Argument of type '(theme: Theme) => { optionContai... Remove this comment to see the full error message
const useStyles = makeStyles((theme: Theme) => ({
  optionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  infoIcon: {
    color: theme.palette.warning.dark,
    pointerEvents: 'auto !important',
  },
}))

type CAContainerNumberSelectorProps = {
  onContainerNumbersChange: (containerNumbers: string[]) => void
  selectedContainerNumbers: string[]
}

export const CAContainerNumberSelector: FC<CAContainerNumberSelectorProps> = ({
  onContainerNumbersChange,
  selectedContainerNumbers,
}) => {
  const { translate } = useI18n()
  const classes = useStyles()

  const { shipment } = useShipmentDetails()

  const isDisabled = !(shipment && shipment.type !== 'lcl')

  const options = useMemo(() => {
    const containerNumbers = shipment?.containers.map((container) => container.containerNumber ?? '') || []
    if (containerNumbers.length === 1 && !isEmpty(containerNumbers[0])) {
      onContainerNumbersChange(containerNumbers)
    }
    return containerNumbers
  }, [onContainerNumbersChange, shipment?.containers])

  const oneContainerSelected = options.length === 1

  const isOptionsDisabled = (option: string) => !option || oneContainerSelected

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      disableClearable={oneContainerSelected}
      limitTags={1}
      label={translate('shipment_details-documents-container_numbers')}
      value={selectedContainerNumbers}
      options={options}
      onChange={(_e, selectedOptions: string[]) => onContainerNumbersChange(selectedOptions)}
      TextFieldProps={{
        role: 'textbox',
        'aria-label': translate('shipment_details-documents-container_numbers'),
        helperText: isDisabled
          ? translate('shipment_details-documents-container_numbers_not_available_for_shipment')
          : '',
      }}
      role="listbox"
      aria-label={translate('shipment_details-documents-container_numbers')}
      noOptionsText={translate('shipment_details-documents-container_numbers_not_available')}
      disabled={isDisabled}
      getOptionDisabled={(option: string) => isOptionsDisabled(option)}
      renderOptionV2={(props, option: string, { selected, index }) => (
        <MenuItem {...props} key={`${index}-${option}`} role="option" aria-label={`${index}-${option}`}>
          <Checkbox checked={selected} color="primary" />
          <Box className={classes.optionContainer}>
            {`#${options.indexOf(option) + 1} ${
              option || translate('shipment_details-documents-container_numbers_missing')
            }`}
          </Box>
        </MenuItem>
      )}
      renderTags={(selections: string[], getTagProps) =>
        selections.map((selection, index) => (
          <Tag
            {...getTagProps({ index })}
            key={`${index}-${selection}`}
            label={selection}
            role="listitem"
            aria-label={selection}
            disabled={oneContainerSelected}
          />
        ))
      }
    />
  )
}
